import clsx from 'clsx';
import { useIAChatWelcomeStyles } from './IAChatWelcome.styles';

const PREDEFINED_QUERIES = [
  'Je rencontre un problème\nJe veux trouver une solution',
  "Je ressens des émotions fortes\nJ'ai besoin d'aide pour mieux les gérer",
  "J'ai besoin qu'on m'aide\nJe veux comprendre une situation compliquée",
];

type IAChatWelcomeProps = {
  isLoading: boolean;
  onSelectPredefinedQuery: (query: string) => void;
};

const IAChatWelcome = ({ isLoading, onSelectPredefinedQuery }: IAChatWelcomeProps) => {
  const classes = useIAChatWelcomeStyles();

  return (
    <div className={classes.welcomeSection}>
      <p className={classes.welcomeText}>Comment puis-je vous aider ?</p>
      <div className={classes.predefinedQueries}>
        {PREDEFINED_QUERIES.map((query, index) => {
          const [title, subtitle] = query.split('\n');
          const isLastQuery = index === PREDEFINED_QUERIES.length - 1;

          return (
            <button
              key={query}
              type="button"
              className={clsx(
                classes.predefinedQueryButton,
                isLastQuery && classes.predefinedQueryButtonWide,
              )}
              onClick={() => onSelectPredefinedQuery(query)}
              disabled={isLoading}>
              <span className={classes.predefinedQueryTitle}>{title}</span>
              <span
                className={clsx(
                  classes.predefinedQuerySubtitle,
                  isLastQuery && classes.predefinedQuerySubtitleWrap,
                )}>
                {subtitle}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default IAChatWelcome;
